
import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../button/Button";
import "../../../styles/typography.css";
import "./ReusableModal.css";

const ReusableModal = ({
  show,
  onHide,
  title = "Modal Title",
  children, // dynamic content (e.g., table, text, form)
  size = "lg", // 'sm', 'md', 'lg', 'xl'
  centered = true,
  buttons = [], // [{ text: 'Cancel', variant: 'outlined', onClick: fn }]
  // backdrop: true | false | 'static' - true: close on click outside, false: no backdrop, 'static': don't close on click outside
  backdrop = 'static',
  // keyboard: boolean - allow closing with ESC key
  keyboard = false,
  scrollable = false,
  dialogClassName = "",
}) => {
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragStartRef = useRef({ x: 0, y: 0 });
  const dragOriginRef = useRef({ x: 0, y: 0 });
  const draggingRef = useRef(false);

  useEffect(() => {
    if (show) {
      setDragOffset({ x: 0, y: 0 });
      setIsDragging(false);
      draggingRef.current = false;
    }
  }, [show]);

  useEffect(() => {
    const handlePointerMove = (event) => {
      if (!draggingRef.current) return;

      const deltaX = event.clientX - dragStartRef.current.x;
      const deltaY = event.clientY - dragStartRef.current.y;

      setDragOffset({
        x: dragOriginRef.current.x + deltaX,
        y: dragOriginRef.current.y + deltaY,
      });
    };

    const handlePointerUp = () => {
      if (!draggingRef.current) return;
      draggingRef.current = false;
      setIsDragging(false);
    };

    window.addEventListener("pointermove", handlePointerMove);
    window.addEventListener("pointerup", handlePointerUp);

    return () => {
      window.removeEventListener("pointermove", handlePointerMove);
      window.removeEventListener("pointerup", handlePointerUp);
    };
  }, []);

  const handleHeaderPointerDown = (event) => {
    if (event.target.closest(".btn-close")) return;

    draggingRef.current = true;
    setIsDragging(true);
    dragStartRef.current = { x: event.clientX, y: event.clientY };
    dragOriginRef.current = { ...dragOffset };
  };

  const modalClassName = [
    "draggable-reusable-modal",
    centered ? "reusable-modal-centered" : "reusable-modal-top",
    isDragging ? "is-dragging" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered={false}
      backdrop={backdrop}
      keyboard={keyboard}
      scrollable={scrollable}
      dialogClassName={dialogClassName}
      className={modalClassName}
      style={{
        "--modal-drag-x": `${dragOffset.x}px`,
        "--modal-drag-y": `${dragOffset.y}px`,
      }}
    >
      <Modal.Header closeButton onPointerDown={handleHeaderPointerDown}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {children}
      </Modal.Body>

      {buttons.length > 0 && (
        <Modal.Footer>
          {buttons.map((btn, index) => (
            <Button
              key={index}
              variant={btn.variant || "active"}
              onClick={btn.onClick}
              className={btn.className || ""}
              title={btn.text}
            >
              {btn.text}
            </Button>
          ))}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ReusableModal;
